import { createContext, useContext } from "react"

type TableHeaderContextType = {
  className?: string
  borderOnScroll?: boolean
}

const TableHeaderContext = createContext<TableHeaderContextType>({})

type Props = TableHeaderContextType & {
  children: React.ReactNode
}

export function TableHeaderProvider({ children, ...valueProp }: Props) {
  const value = valueProp

  return (
    <TableHeaderContext.Provider value={value}>
      {children}
    </TableHeaderContext.Provider>
  )
}

export function useTableHeader() {
  return useContext(TableHeaderContext)
}
